// hooks/useOptionConfig.ts
import { Option, SelectedItems } from "@/types/productTypes";
import { useEffect, useRef } from "react";
import { useFormContext } from "react-hook-form";

export function useOptionConfig(option: Option, defaultValue?: SelectedItems) {
   const id = option.id;
   const { watch, setValue } = useFormContext();
   const first = useRef(true);
   function handleChange(newSelectedItem: string | string[]) {
      if (!option.id) return;
      setValue(option.id.toString(), {
         selectedItem: newSelectedItem,
         selected: true,
      });
   }
   if (!id) {
      return {
         fieldValue: {
            selectedItem: "-1",
            selected: false,
         },
         handleChange,
      };
   }
   const fieldValue: SelectedItems = watch(id.toString());
   console.log("defaultField", fieldValue);

   useEffect(() => {
      console.log("Itemalue", fieldValue, defaultValue);
      if (first.current && defaultValue?.selectedItem === "-1") {
         setValue(id.toString(), defaultValue);
         first.current = false;
      }
      if (
         (fieldValue === undefined || fieldValue.selectedItem === "-1") &&
         defaultValue &&
         defaultValue.selectedItem !== "-1"
      ) {
         setValue(id.toString(), defaultValue);
      }
   }, [fieldValue, defaultValue, option.id, setValue]);

   return {
      fieldValue,
      handleChange,
   };
}
